/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useCallback, useEffect, useState } from 'react';
import { Form } from '@unform/web';
import UseAnimations from 'react-useanimations';
import alertCircle from 'react-useanimations/lib/alertCircle';
import { FiAlertCircle } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import Button from '../../../../components/Global/Button';
import OrderServiceTableFiscal from '../../../../components/Admin/OrderServiceTableFiscal';
import Select from '../../../../components/Global/Select';
import Input from '../../../../components/Global/Input';

import ModalServicesOrdersFiscal from '../../../../components/Admin/Modal/ModalServicesOrdersFiscal';

import {
  handleSendEmailOpenOrderServiceFiscal,
  handleSendEmailOpenOrderServiceUser,
} from '../../../../services/sendEmailOpenOrderServiceFiscal';

import { useAuth } from '../../../../hooks/auth';

import { CardButton, CardeHeader, Container, CardInfo } from './styles';
import { api } from '../../../../services/api';

interface PropsItem {
  title?: string;
}

// interface Iuser {
//   access: {
//     id: string;
//     name: string;
//     nickname: string;
//     status: string;
//     tag: string;
//     email: string;
//     dashboard: boolean;
//     goals_and_sub_goals: boolean;
//     sector: boolean;
//     employers: boolean;
//     module_analyze: boolean;
//     imports: boolean;
//     report: boolean;
//     service_send_email: boolean;
//     schedule: boolean;
//   };
// }

interface IdataTable {
  created_at: string;
  email: string;
  id: string;
  name: string;
  observations: string;
  reason: string;
  status: string;
  type: string;
  updated_at: string;
  // urgency: string;
  identification: number;
  file: string;
  reason_observation: string;
}

interface IFilter {
  finishedDateIn: string;
  finishedDateOut: string;
  startDateIn: string;
  startDateOut: string;
  status: string;
  urgency: string;
  type: string;
}

const Reports: React.FC<PropsItem> = ({ title }) => {
  const { user } = useAuth();
  const [modalOpen, setModalOpen] = useState(false);
  const [toogleFilter, setToogleFilter] = useState(true);
  const [reloadTable, setReloadTable] = useState('');

  const [dataFilter, setDataFilter] = useState<IFilter>({
    finishedDateIn: '',
    finishedDateOut: '',
    startDateIn: '',
    startDateOut: '',
    status: '',
    urgency: '',
    type: '',
  });

  const [textStatusServices, setTextStatusServices] = useState('Carregando...');
  const [statusServices, setStatusServices] = useState('loading');

  useEffect(() => {
    api.get<IdataTable[]>('/services-orders?type=Fiscal');
    // .then(async (response: { data: any[] }) => {
    //   const { status } = (

    // id do Fagner atualizado.
    //     await api.get<Iuser>('/accesses/c19a3179-be7c-4b08-bf8e-d430c21c5b0c')
    //   ).data.access;

    //   if (status === 'Presente') {
    //     const servicesFiltred = response.data.filter(
    //       item => item.status === 'Andamento',
    //     );
    //     if (servicesFiltred.length > 0) {
    //       setTextStatusServices(
    //         `Fiscal esta em ${servicesFiltred.length} ${
    //           servicesFiltred.length > 1 ? 'Atendimentos' : 'Atendimento'
    //         } no momento`,
    //       );
    //       setStatusServices('info');
    //     } else if (servicesFiltred.length <= 0) {
    //       setTextStatusServices('Fiscal está aguardando novas OS');
    //       setStatusServices('success');
    //     }
    //   } else {
    //     setTextStatusServices('Fiscal está ausente no momento');
    //     setStatusServices('waring');
    //   }
    // });
  }, [user]);

  const toggleModal = useCallback(() => {
    setModalOpen(!modalOpen);
  }, [modalOpen]);

  const handleAnalytic = useCallback(
    async (servicesOrders: Omit<IdataTable, 'e'>) => {
      try {
        const temp = servicesOrders;
        // setServicesOrders(temp);
        handleSendEmailOpenOrderServiceFiscal(temp);
        handleSendEmailOpenOrderServiceUser(temp, user);
      } catch (err) {
        console.log(err);
      }
    },
    [user],
  );

  const handleFilter = useCallback((data: IFilter) => {
    setDataFilter(data);
  }, []);

  const handleToogleFilter = useCallback(() => {
    setToogleFilter(!toogleFilter);
  }, [toogleFilter]);

  return (
    <>
      <ModalServicesOrdersFiscal
        isOpen={modalOpen}
        setIsOpen={toggleModal}
        handleAnalytic={handleAnalytic}
        setReloadTable={setReloadTable}
      />
      <Container toogleFilter={toogleFilter}>
        <CardeHeader titleItem={title}>
          <div>
            <h2>
              Ordens de serviços - Fiscal{' '}
              <Link
                target="__black"
                to="/rules/sector-resume-rules?solicitacao-de-servico-para-fiscal"
              >
                {' '}
                <FiAlertCircle size={20} />{' '}
              </Link>
            </h2>
            <strong>Abra novos chamados de serviços</strong>
          </div>

          <CardButton>
            <div>
              <Button
                isUsed
                onClick={toggleModal}
                groud={false}
                disabled={false}
              >
                Nova ordem
              </Button>
            </div>
          </CardButton>
        </CardeHeader>
        <CardInfo>
          <div className={statusServices}>
            <span>
              <UseAnimations
                animation={alertCircle}
                size={40}
                strokeColor="#ddca20"
                style={{ padding: 50 }}
              />
              <header>
                <h4>Status para atendimento</h4>
                <strong>{textStatusServices}</strong>
              </header>
            </span>
          </div>
        </CardInfo>
        <section className="section-filter">
          <header>
            <Button
              isUsed
              type="button"
              onClick={handleToogleFilter}
              groud={false}
              disabled={false}
            >
              <p>Filtro</p>
            </Button>
          </header>

          <Form onSubmit={handleFilter}>
            <section>
              <div>
                <fieldset className="fieldset-category">
                  <legend>Categoria</legend>

                  {/* <p>Nivel de urgencia</p>

                  <Select
                    name="urgency"
                    options={[
                      {
                        label: 'Vazio',
                        value: '',
                      },
                      {
                        label: 'Baixo',
                        value: 'baixo',
                      },
                      {
                        label: 'Médio',
                        value: 'medio',
                      },
                      {
                        label: 'Alto',
                        value: 'alto',
                      },
                    ]}
                  /> */}
                  {/* <select>
                  <option>Baixo</option>
                  <option>Médio</option>
                  <option>Alto</option>
                </select> */}

                  <p>Status</p>
                  <Select
                    name="status"
                    options={[
                      {
                        label: 'Vazio',
                        value: '',
                      },
                      {
                        label: 'Pendente',
                        value: 'Pendente',
                      },
                      {
                        label: 'Finalizado',
                        value: 'Finalizado',
                      },
                    ]}
                  />
                </fieldset>
              </div>

              <fieldset>
                <legend>Data da solicitação</legend>
                <div>
                  <p>Data inicial</p>
                  <Input type="date" name="startDateIn" />

                  <p className="space-top">Data final</p>
                  <Input type="date" name="startDateOut" />
                </div>
              </fieldset>

              <fieldset>
                <legend>Data de atendimento</legend>
                <div>
                  <p>Data inicial</p>
                  <Input type="date" name="finishedDateIn" />

                  <p className="space-top">Data final</p>
                  <Input type="date" name="finishedDateOut" />
                </div>
              </fieldset>
              <span>
                <Button isUsed type="submit" groud={false} disabled={false}>
                  Aplicar filtro
                </Button>
              </span>
            </section>
          </Form>
        </section>
        <div className="section-body">
          <OrderServiceTableFiscal
            email={user.email}
            filterData={dataFilter}
            reloadTable={reloadTable}
          />
        </div>
      </Container>
    </>
  );
};

export default Reports;
